// |Angular 4.0 imports
import { Component, OnInit }                            from '@angular/core';
import { Http }                                         from '@angular/http';
import { RequestOptions }                               from '@angular/http';
import { Injectable }                                   from '@angular/core';
import { Headers }                                      from '@angular/http';
// |Application imports
import { Locale }                                       from './../../service/locale.service';
import { InternalFunctionsRedirectService }             from './../../service/internalFunctionsRedirectService.service';
import { AccountService }                               from './../../service/accountService.service';
import { LabelFormatService }                           from './../../service/labelFormatService.service';
import { CustomizingService }                           from './../../service/customizingService.service';
import { Status } 	                                    from './../../service/status.service';

// |Class containing informations about the profiles rendering and behaviour
export class ProfileExpansion {
    public profile;
    public expanded = false;
    public id;
}

/*
// |Class containing informations about the sales areas rendering and behaviour
export class SalesAreaInfo {
    public salesArea;
    public id;
    public profileID;
}
*/

// |Component configuration
@Component({
  selector: 'app-select-profile',
  templateUrl: './select-profile.component.html'
})
export class SelectProfileComponent {

    // |Handles the animation of the modal
    public visible = false;
    public visibleAnimate = false;

    // |Contains the possible selections of the user
    public profileStatus = [];
    //public salesAreaInfos = [];

    // |Contains the logic values
    public closeable = false;
    public profileID;
    //public usaID;

    // |Sorting values
    private sortType = '';
    private sortReverse = false;

    // |Contain the customization preferencies
    private showCompanyCode;
    private showCompanyDescription;
    /*
    private showBusinessOrganizationCode;
    private showBusinessOrganizationDescription;
    private showChannelCode;
    private showChannelDescription;
    private showSectorCode;
    private showSectorDescription;
    */

    // |Where the component logic start
    constructor(private locale:             Locale,
                private labelFormatService: LabelFormatService,
                private customizingService: CustomizingService,
                private status:             Status,
                private IFHS:               InternalFunctionsRedirectService,
                private accountService:     AccountService) {
    }

    // |Set the customization values
    private setParametersStylingValues() {
        this.showCompanyCode = this.getBoolean('PROFILE.COMPANY.CODE.SHOW', 'FALSE');
        this.showCompanyDescription = this.getBoolean('PROFILE.COMPANY.DESCRIPTION.SHOW', 'FALSE');
        /*
        this.showChannelCode = this.getBoolean('PROFILE.CHANNEL.CODE.SHOW', 'FALSE');
        this.showChannelDescription = this.getBoolean('PROFILE.CHANNEL.DESC.SHOW', 'FALSE');
        this.showSectorCode = this.getBoolean('PROFILE.SECTOR.CODE.SHOW', 'FALSE');
        this.showSectorDescription = this.getBoolean('PROFILE.SECTOR.DESC.SHOW', 'FALSE');
        */
    }

    // |Set the sort column
    setSortColumn(value: string) {
        if (value === this.sortType) {
            this.sortReverse = !this.sortReverse;
        } else {
            this.sortType = value;
        }
    }

    // |Returns if the column is used as small to big sorting or not
    ascSorting(value: string) {
        if (value === this.sortType) {
            if (this.sortReverse === true) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // |Returns if the column is used as big to small sorting or not
    desSorting(value: string) {
        if (value === this.sortType) {
            if (this.sortReverse === false) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // |Returns if the column is used as sorting value or not
    notSortedByThis(value: string) {
        if (value === this.sortType) {
            return false;
        } else {
            return true;
        }
    }

    // |Pre-process all the selectable profiles by the user
    public recalcProfiles() {
        // clear the stored data
        this.profileStatus = [];
        //this.salesAreaInfos = [];
        // prepare the loop variables
        const def_value = true;
        let a = 0;
        // for each profile in my profiles...
        for (const profile of this.accountService.getStoredProfiles() ) {
            // ...create a new profile expansion object...
            const newProfile = new ProfileExpansion();
            // ...insert the sensible data for this context...
            newProfile.expanded = true;
            newProfile.profile = profile;
            newProfile.id = a;
/*
            let j = 0;
            // ...and for each sales areas of my user
            for (const usa of profile.user_sales_areas) {
                // ...create a new sales area info object...
                const newSalesAreaInfo = new SalesAreaInfo();
                // ...insert the sensible data for this context...
                newSalesAreaInfo.salesArea = usa;
                newSalesAreaInfo.id = j;
                newSalesAreaInfo.profileID = a; // bind the sales area to the right profile
                // ...add it in all my sales areas roster choises...
                this.salesAreaInfos.push(newSalesAreaInfo);
                j++;
            }
*/
            a++;

            // ...and add this profiles to the elaborate profiles
            this.profileStatus.push(newProfile);
        }

    }

    // |Show the modal to the user
    public show() {
        this.visible = true;
        // load the costumizations and elaborate all the profiles selectable by the user before the rendering in the layout
        this.setParametersStylingValues();
        this.recalcProfiles();
        // if no profile has been selected do not allow the user to close the modale, otherwise enable this feature
        if (this.profileStatus.length === 0) { this.closeable = false; } else { this.closeable = true; }
        setTimeout(() => this.visibleAnimate = true, 100);
    }

    // |Hide the modal to the user
    public hide() {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false, 100);
    }

    // |Expand (or not) a profile for the visualization
    public expandProfile(value) {
         for (const profile of this.profileStatus) {
             if (profile.profile === value) {
                 profile.expanded = !profile.expanded;
             }
         }
    }

    // |Trigger the init profile with the right data
    public setLoginValues(modalProfile){//, modalUsa) {
        // for each profile in my profiles...
        for (const profile of this.profileStatus) {
            // ...check if the profile is the same that the user selected...
            if (profile.profile === modalProfile) {
                // ...and get his id and finally break the loop
                this.profileID = profile.id;
                break;
            }
        }
        /*
        // for each sales area in my sales areas...
        for (const usa of this.salesAreaInfos) {
            // ...check if the sales area is the same that the user selected and belongs to the profile selected...
            if (usa.salesArea === modalUsa && this.profileID === usa.profileID) {
                // ...and get his id and finally break the loop
                this.usaID = usa.id;
                break;
            }
        }
        */
        // launch the init profile with the collected data and hide the modal
        this.accountService.initProfile(this.profileID);//, this.usaID);
        if (this.IFHS.getSidebar() !== undefined) {
            this.IFHS.getSidebar().setMenuItem('');
            this.status.getAppComponent().actualAppZone = '';
            setTimeout(() => this.restartAppRendering(), 100);
        }
        this.hide();
    }

    restartAppRendering() {
        this.status.getAppComponent().actualAppZone = '';
        if (this.status.getIsAgent() === true ||
            this.status.getIsManager() === true ||
            this.status.getIsDirectionalUser() === true) {
            this.IFHS.getSidebar().setMenuItem('rolelist');
            this.status.getAppComponent().actualAppZone = 'rolelist';
        } else {
            this.IFHS.getSidebar().setMenuItem('home');
            this.status.getAppComponent().actualAppZone = 'home';
        }
    }
    
    // |Get the profile id of a JSON object
    public getProfileID(value) {
        return this.profileID;
    }

/*
    // |Get the sales area id of a JSON object
    public getSalesAreaID() {
        return this.usaID;
    }
 */

    // |Get if the given profile has been expanded or not
    getProfileExpansionStatus(value) {
        for (const profile of this.profileStatus) {
             if (profile.profile === value) {
                 return profile.expanded;
             }
         }
    }

    // |Hides the modal if the user click outside his bounds
    public onContainerClicked(event: MouseEvent): void {
        if ((<HTMLElement>event.target).classList.contains('selectprofileModal')) {
            this.hide();
        }
    }

    // |Function wrappers
    getTerms()                      { return this.locale.getTerms(); }
    getBoolean(key, defValue)       { return this.customizingService.getBoolean(key, defValue); }
    extractNumberLabel(value)       { return this.labelFormatService.extractNumberLabel(value); }
}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-select-profile/select-profile.component.ts